import React, { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import Loading from './components/Loading';
// layouts
import ZotacLayout from './layout/zotac';
import CleanLayout from './layout/cleanLayout/CleanLayout';

const LoginPage = lazy(() => import('./pages/LoginPage'));
const Page404 = lazy(() => import('./pages/Page404'));
const CustomersPage = lazy(() => import('./pages/CUSTOMERS/CustomersPage'));
const RmasPage = lazy(() => import('./pages/RMAS/RmasPage'));
const RmaPage = lazy(() => import('./pages/RMA/RmaPage'));
const WareHousePage = lazy(() => import('./pages/WAREHOUSE/WareHousePage'));
const CustomerPage = lazy(() => import('./pages/CUSTOMER/CustomerPage'));
const CallbackPage = lazy(() => import('./pages/CALLBACK/CallbackPage'));
const ArticlePage = lazy(() => import('./pages/ARTICLE/ArticlePage'));
const LogoutPage = lazy(() => import('./pages/LOGOUT/LogoutPage'));
const AccountPage = lazy(() => import('./pages/ACCOUNT/AccountPage'));
const NotificationsPage = lazy(() => import('./pages/NOTIFICATIONS/NotificationsPage'));
const DashboardPage = lazy(() => import('./pages/DASHBOARD/DashboardPage'));
const ReportsPage = lazy(() => import('./pages/REPORTS/ReportsPage'));
const NewCustomer = lazy(() => import('./pages/NEWCUSTOMER/NewCustomer'));
const DBZotac = lazy(() => import('./pages/DBZOTAC/DBZotac'));
const PalettePage = lazy(() => import('./pages/PALETTE/PalettePage'));
const AdminPage = lazy(() => import('./pages/ADMIN/AdminPage'));
const ArticlesPage = lazy(() => import('./pages/ARTICLES/ArticlesPage'));
const EmailTrafficPage = lazy(() => import('./pages/EMAILTRAFFIC/EmailTrafficPage'));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      element: <ZotacLayout />,
      children: [
        { element: <Navigate to="/customers" />, index: true },
        { path: 'dashboard', element: <DashboardPage /> },
        { path: 'customers', element: <CustomersPage /> },
        { path: 'customer/:id', element: <CustomerPage /> },
        { path: 'customer/:id/rma/:idRma', element: <RmaPage /> },
        { path: 'rma/:idRma', element: <RmaPage /> },
        { path: 'rmas', element: <RmasPage /> },
        { path: 'warehouse', element: <WareHousePage /> },
        { path: 'account', element: <AccountPage /> },
        { path: 'notifications', element: <NotificationsPage /> },
        { path: 'reports', element: <ReportsPage /> },
        { path: 'new-customer', element: <NewCustomer /> },
        { path: 'db-zotac', element: <DBZotac /> },
        { path: 'palette', element: <PalettePage /> },
        { path: 'article/:id', element: <ArticlePage /> },
        { path: 'articles', element: <ArticlesPage /> },
        { path: 'admin', element: <AdminPage /> },
        { path: 'email-traffic', element: <EmailTrafficPage /> },
      ],
    },
    {
      path: '/auth',
      children: [
        { element: <Navigate to="/auth/login" />, index: true },
        { path: 'login', element: <LoginPage /> },
        { path: 'callback', element: <CallbackPage /> },
        { path: 'logout', element: <LogoutPage /> },
      ],
    },
    {
      element: <CleanLayout />,
      children: [
        { element: <Navigate to="/customers/" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
  ]);

  return <Suspense fallback={<Loading />}>{routes}</Suspense>;
}
